import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { loginUser } from "./userSlice";
import { useLocation, useNavigate } from "react-router-dom";

function Login() {
  document.title = "Login - To Do App";
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // @ts-ignore
  let from = location.state?.from?.pathname || "/";

  const user = useAppSelector((state) => state.user.token);
  const responseError = useAppSelector((state) => state.user.errors);
  const responseStatus = useAppSelector((state) => state.user.status);

  // Local State
  const [formData, setFormData] = React.useState({
    email: "",
    password: "",
  });
  const [error, setError] = React.useState({
    email: "",
    password: "",
  });
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError({ ...error, email: "", password: "" });
    console.log(formData);
    await dispatch(loginUser(formData));
    setIsSubmitting(false);
  };

  useEffect(() => {
    if (user) {
      // Send them back to the page they tried to visit when they were
      // redirected to the login page. Use { replace: true } so we don't create
      // another entry in the history stack for the login page.  This means that
      // when they get to the protected page and click the back button, they
      // won't end up back on the login page, which is also really nice for the
      // user experience.
      navigate(from, { replace: true });
    }
  }, [isSubmitting, from, navigate, user]);

  if (!user) {
    return (
      <div className="login">
        <h2>Login</h2>
        {responseStatus === "failed" && (
          <ul className="errors-list">
            {responseError?.map((err, index) => (
              <li key={index}>{err}</li>
            ))}
          </ul>
        )}
        <form autoComplete="off" onSubmit={handleSubmit}>
          <label id="email">Email</label>
          <input
            required
            type="email"
            name="email"
            id="email"
            onChange={handleChange}
            placeholder="email"
          />
          <label id="password">Password</label>
          <input
            required
            type="password"
            name="password"
            id="password"
            onChange={handleChange}
            placeholder="password"
            maxLength={20}
            minLength={6}
          />
          <Link to="/">Forgot password ?</Link>
          <button className="btn-primary" disabled={isSubmitting} type="submit">
            Login
          </button>
          <p>
            Don't have an account ? <Link to="/signup">Signup</Link>
          </p>
        </form>
      </div>
    );
  }
  return <div></div>;
}

export default Login;
